import { ReactNode } from "react";
import { PublicFrame } from "./PublicFrame";
import type { StatusKind } from "./StatusArt";
import s from "./public.module.scss";

/** One status screen of the new frame (board 302): waiting for review, no workspace, inactive, package pending. The words are today's, handed in. */
export const StatusPage = ({ title, children, actions, tone = "info", art = "ok" }: { title: ReactNode; children?: ReactNode; actions?: ReactNode; tone?: "info" | "warn"; art?: StatusKind }) => (
  <PublicFrame title={title} center statusArt={art}>
    {children && <div className={`${s.statusText} ${tone === "warn" ? s.statusWarn : ""}`}>{children}</div>}
    {actions && <div className={s.actions}>{actions}</div>}
  </PublicFrame>
);

/** A primary / quiet button for status screens. */
export const StatusButton = ({ children, onClick, primary, href }: { children: ReactNode; onClick?: () => void; primary?: boolean; href?: string }) =>
  href ? <a className={primary ? s.btnPrimary : s.btnQuiet} href={href}>{children}</a>
       : <button type="button" className={primary ? s.btnPrimary : s.btnQuiet} onClick={onClick}>{children}</button>;
